import React, { useState } from "react";
import { ModalComponent } from "../../../../../../../Components/Modal";
import { VariableProductPage } from "../../../VariableProductLayout";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../../../../../Helpers/currency";

export const VariableProductComponent = ({
  product,
  selectProduct,
  isSelected,
}) => {
  const [show, setShow] = useState(false);
  const [selectedVariation, setSelectedVariation] = useState(null);
  const { t } = useTranslation();

  function handleVariationSelection(variation) {
    if (variation) {
      setSelectedVariation(variation);
      selectProduct({ ...product, variation: variation });
    } else {
      setSelectedVariation(null);
      selectProduct({ ...product, variation: null }, true);
    }
  }

  const active = isSelected || selectedVariation;

  return (
    <>
      <div
        role="button"
        className={`p-3 border rounded-3 h-100 text-center position-relative ${
          active ? "border-success bg-light" : ""
        }`}
        onClick={() => {
          if (!selectedVariation) {
            setShow(true);
          } else {
            handleVariationSelection(null);
          }
        }}
        style={{ cursor: "pointer", transition: "all 0.15s ease" }}
      >
        {active && (
          <span
            className="position-absolute top-0 end-0 mt-1 me-2 text-danger fw-bold"
            style={{ fontSize: "1.1rem", lineHeight: 1 }}
          >
            &times;
          </span>
        )}
        <div className={active ? "fw-bold small" : "small"}>
          {selectedVariation
            ? t(selectedVariation.name)
            : t(product.name)}
        </div>
        {!selectedVariation && (
          <div className="text-muted small mt-1">{t("seleccionar opción")}</div>
        )}
        {(selectedVariation || product.price) && (
          <div className="fw-medium text-muted small mt-1">
            {selectedVariation
              ? formatCurrency(selectedVariation.regular_price)
              : product.price
                ? formatCurrency(product.price)
                : ""}
          </div>
        )}
      </div>

      <ModalComponent
        show={show}
        setShow={setShow}
        title={t(product.name)}
        size="lg"
      >
        <VariableProductPage
          product={product}
          setSelectedVariation={handleVariationSelection}
          setShow={setShow}
          isModal={true}
        />
      </ModalComponent>
    </>
  );
};
